module.exports = __webpack_public_path__ + "ecf4ebdd3c0871ac4df5706604c9b86c.pdf";